import { InsightsPrediction, Period } from '@api';
import { PredictionRow } from '@terminal/widgets/scenario/components/prediction-summary-table/PredictionSummaryTable';

export const getPredictionsTableData = (
  horizons: string[],
  predictions: InsightsPrediction[]
) => {
  return horizons.reduce((result, horizon) => {
    const prediction = predictions.find(
      prediction => prediction.horizon === horizon
    );

    if (prediction) {
      result[horizon as Period] = {
        max: prediction.max,
        p80: prediction.percentiles['80'],
        median: prediction.median,
        mean: prediction.mean,
        p20: prediction.percentiles['20'],
        min: prediction.min,
      };
    }

    return result;
  }, {} as Record<Period, PredictionRow>);
};
